import React, { useRef, useState, useEffect } from "react";
import SnackBar from "../../../GeneralComponents/SnackBar";
import useFetch from "../../CustomHooks/useFetch";
import Button from "../../../GeneralComponents/Button";
import InputFileName from "./../../StaffManagement/Profile/InputFileName";
import WarningModal from "./../../StaffManagement/Profile/WarningModal";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import InputDropDown from "./InputDropDown";
import styles from "./DocumentsTab.module.scss";

const OPTIONS = { year: "numeric", month: "long", day: "numeric" };
const DocumentsTab = ({ data, ...props }) => {
  const { t } = useTranslation();
  const accessibilityData = useSelector((state) => state).accessibility;
  const inputRef = useRef();
  const snackBarRef = useRef();
  const [snackBarContent, setSnackBarContent] = useState("");
  const staffId = props._id;
  useEffect(() => {
    setAllDocumentBody(null);
    setAllDocumentBody(JSON.stringify({ daycareProfessionalID: staffId }));
  }, [staffId]);
  const [getAllDocumentBody, setAllDocumentBody] = useState(
    JSON.stringify({ daycareProfessionalID: staffId })
  );

  const [fileType, setFileType] = useState(false);
  const [fileName, setFileName] = useState(null);
  const [fileData, setFileData] = useState(null);
  const [verifyStaffBody, setVerifyStaffBody] = useState(null);
  const [docType, setDocType] = useState(t("Select an Option"));
  const [docData, setDocData] = useState([]);
  const [uploadDocumentBody, setUploadDocumentBody] = useState(null);
  const [direction, setDirection] = useState([null, null, null, null]);
  const [filteredData, setFilteredData] = useState(null);

  const [selectedDocs, setSelectedDocs] = useState(0);
  const [totalDocs, setTotalDocs] = useState(0);

  const [uploadToStripeBody, setUploadToStripeBody] = useState(null);
  const [getDocumentURLBody, setDocumentURLBody] = useState(null);
  const [deleteDocumentBody, setDeleteDocumentBody] = useState(null);
  const [edit, setEdit] = useState(false);
  const [updateDocumentBody, setUpdateDocumentBody] = useState(null);
  const [documentID, setDocumentID] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [verification, setVerification] = useState(false);
  const [popOverMessage, setPopOverMessage] = useState("");
  const [disableVerifyWithStripe, setDisableVerifyWithStripe] = useState(false);

  const [snackError, setSnackError] = useState(false);
  //api for uploading the identificationDocument
  const uploadToStripe = useFetch({
    url: "/daycareprofessional/uploadtostripe",
    method: "POST",
    body: uploadToStripeBody,
    accessibility: accessibilityData["Child Profile"],
  });

  const uploadDocument = useFetch({
    url: "/childdocuments/addDocument",
    method: "POST",
    body: uploadDocumentBody,
    contentType: false,
    accessibility: accessibilityData["Child Profile"],
  });

  const getAllDocuments = useFetch({
    url: "/childdocuments/allDocuments",
    method: "POST",
    body: JSON.stringify({
      childID: data?._id,
    }),
  });

  const getDocumentURL = useFetch({
    url: "/childdocuments/viewDocument",
    method: "POST",
    body: getDocumentURLBody,
  });

  const deleteDocument = useFetch({
    url: "/childdocuments/deleteDocument",
    method: "POST",
    body: deleteDocumentBody,
    accessibility: accessibilityData["Child Profile"],
  });

  const updateDocument = useFetch({
    url: "/childdocuments/updateDocument",
    method: "POST",
    body: updateDocumentBody,
    contentType: false,
    accessibility: accessibilityData["Child Profile"],
  });

  useEffect(() => {
    if (uploadDocument.response) {
      setSnackError(false);
      setSnackBarContent(uploadDocument.response.message);
      setDocType(t("Select an Option"));
      setFileType(false);
      setFileName(null);
      setFileData(null);
      snackBarRef.current.openSnackBar();
      setDocData(uploadDocument.response.documents);
    }
    if (uploadDocument.error) {
      setSnackError(true);
      setSnackBarContent(uploadDocument.error);
      snackBarRef.current.openSnackBar();
    }
  }, [uploadDocument.response, uploadDocument.error]);

  useEffect(() => {
    if (updateDocument.response) {
      setDocType(t("Select an Option"));
      setFileType(false);
      setFileName(null);
      setFileData(null);
      setSnackBarContent(updateDocument.response.message);
      snackBarRef.current.openSnackBar();
      setDocData(updateDocument.response.documents);
    }
  }, [updateDocument.response, updateDocument.error]);

  useEffect(() => {
    console.log(getAllDocuments.response);
    if (getAllDocuments.response) {
      setDocData(getAllDocuments.response.documents);
      setTotalDocs(getAllDocuments.response.documents.length);
    }
  }, [getAllDocuments.response]);

  useEffect(() => {
    const body = getDocumentURL.response;
    if (body) {
      console.log(body.document);
      var link = document.createElement("a");
      link.href = body.document;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      link.remove();
      setDocumentURLBody(null);
    }
  }, [getDocumentURL.response, getDocumentURL.error]);

  useEffect(() => {
    if (deleteDocument.response) {
      setSnackBarContent(deleteDocument.response.message);
      snackBarRef.current.openSnackBar();
      setDocData(deleteDocument.response.documents);
    }
  }, [deleteDocument.response]);

  const changeHandler = (event) => {
    const value = inputRef.current.value.split("\\").pop();
    let displayVal;
    displayVal = value;
    setFileName(displayVal);
    setFileData(event.target.files[0]);
    setFileType(true);
  };

  const [error, setError] = useState(null);
  //this is for api: /daycareprofessional/uploaddocument
  const handleUploadDocument = (event) => {
    event.preventDefault();
    if (docType === t("Select an Option")) {
      setError(t("Select a document type"));
    } else {
      setError(null);
      if (edit === false) {
        console.log("upload document");
        setAllDocumentBody(null);
        setDocData([
          ...docData,
          {
            documentName: fileName,
            documentType: docType,
            createdAt: new Date().toLocaleDateString("en-EN", OPTIONS),
            updatedAt: new Date().toLocaleDateString("en-EN", OPTIONS),
          },
        ]);
        const formdata = new FormData();
        formdata.append("childID", data._id);
        formdata.append("document", fileData);
        formdata.append("documentName", fileName);
        formdata.append("documentType", docType);
        setUploadDocumentBody(formdata);
      } else {
        console.log("update document");
        setAllDocumentBody(null);
        const formdata = new FormData();
        formdata.append("childID", data._id);
        formdata.append("documentID", documentID);
        formdata.append("document", fileData);
        formdata.append("documentName", fileName);
        formdata.append("documentType", docType);
        setUpdateDocumentBody(formdata);
      }
      setFileType(false);
    }
  };

  const documentViewHandler = (id) => {
    console.log(id);
    setDocumentURLBody(JSON.stringify({ childID: data._id, documentID: id }));
  };

  const handleDeleteDocument = () => {
    setAllDocumentBody(null);
    setDeleteDocumentBody(
      JSON.stringify({ childID: data._id, documentID: documentID })
    );
  };

  return (
    <div>
      {isOpen && (
        <WarningModal
          isOpen={isOpen}
          title="Delete child document?"
          message="This document will be removed from the child profile. This action cannot be undone."
          onConfirmation={() => {
            handleDeleteDocument();
          }}
          handleToggle={() => {
            setIsOpen(!isOpen);
            setDocumentID(null);
          }}
        />
      )}
      <SnackBar
        isError={snackError}
        ref={snackBarRef}
        content={snackBarContent}
      />
      {fileType && fileName && (
        <form className={styles.uploadPanel} onSubmit={handleUploadDocument}>
          <div className={styles.uploadGrid}>
            <InputFileName
              name="fileName"
              label="Document Name"
              value={fileName}
              onChange={(event) => setFileName(event.target.value)}
            />
            <InputDropDown
              name="documentType"
              value={docType}
              label="Document Type"
              defaultName="Select an Option"
              options={[
                "Contract",
                "Identity Proof",
                "Report Card",
                "Medical Record",
                "Birth Certificate",
                "Transfer Certificate",
                "Residence Proof",
                "Vaccination Certificate",
                "Tax Document",
                "Salary Proof",
                "Others",
              ]}
              onChange={(event) => setDocType(event.target.value)}
            />
          </div>
          <div className={styles.uploadActions}>
            {error ? <p className={styles.errorText}>{error}</p> : null}
            <Button
              disabled={accessibilityData["Child Profile"] === "Read"}
              type="submit"
              className={styles.uploadButton}
            >
              {edit ? t("Update") : t("Upload")}
            </Button>
          </div>
        </form>
      )}
      <div className={styles.documentsShell}>
        <input
          type="file"
          ref={inputRef}
          style={{ display: "none", fontSize: 0 }}
          onChange={changeHandler}
          accept="image/*"
        />
        <div className={styles.documentsHeader}>
          <div>
            <h3>{t("Documents")}</h3>
            <p>
              {docData.length} {docData.length === 1 ? t("document") : t("documents")}
            </p>
          </div>
          <button
            type="button"
            data-testid="button-add"
            className={styles.addButton}
            disabled={accessibilityData["Child Profile"] === "Read"}
            onClick={() => {
              setEdit(false);
              inputRef.current.click();
            }}
          >
            <span className="material-icons">add</span>
            {t("Add Document")}
          </button>
        </div>
        <div className={styles.tableWrap}>
          <table className={styles.documentsTable}>
            <thead>
              <tr>
                <th>{t("Document Name")}</th>
                <th>{t("Document Type")}</th>
                <th>{t("Create Date")}</th>
                <th>{t("Modified Date")}</th>
                <th>{t("Actions")}</th>
              </tr>
            </thead>
            <tbody>
              {docData.length ? (
                docData.map((documentItem) => (
                  <tr key={documentItem._id || documentItem.documentName}>
                    <td>
                      <div className={styles.documentNameCell}>
                        <span className="material-icons">description</span>
                        <div>
                          <strong title={documentItem.documentName}>
                            {documentItem.documentName}
                          </strong>
                          {documentItem.uploadedOnStripe ? (
                            <small>{documentItem.stripeVerificationStatus}</small>
                          ) : null}
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className={styles.typePill}>
                        {documentItem.documentType}
                      </span>
                    </td>
                    <td>
                      {new Date(documentItem.createdAt).toLocaleDateString(
                        "en-EN",
                        OPTIONS
                      )}
                    </td>
                    <td>
                      {new Date(documentItem.updatedAt).toLocaleDateString(
                        "en-EN",
                        OPTIONS
                      )}
                    </td>
                    <td>
                      <div className={styles.actionGroup}>
                        <button
                          type="button"
                          className={styles.iconButton}
                          onClick={() => documentViewHandler(documentItem._id)}
                          aria-label={t("Download document")}
                          title={t("Download document")}
                        >
                          <span className="material-icons">download</span>
                        </button>
                        {accessibilityData["Child Profile"] !== "Read" ? (
                          <>
                            <button
                              type="button"
                              className={styles.iconButton}
                              onClick={() => {
                                inputRef.current.click();
                                setDocumentID(documentItem._id);
                                setEdit(true);
                              }}
                              aria-label={t("Edit document")}
                              title={t("Edit document")}
                            >
                              <span className="material-icons">edit</span>
                            </button>
                            <button
                              type="button"
                              className={`${styles.iconButton} ${styles.dangerButton}`}
                              onClick={() => {
                                setDocumentID(documentItem._id);
                                setIsOpen(true);
                              }}
                              aria-label={t("Delete document")}
                              title={t("Delete document")}
                            >
                              <span className="material-icons">delete_outline</span>
                            </button>
                          </>
                        ) : null}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">
                    <div className={styles.emptyState}>
                      <span className="material-icons">folder_open</span>
                      <strong>{t("No documents to display.")}</strong>
                      <p>{t("Add documents by clicking on Add Document button.")}</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DocumentsTab;
